import { CSSObject } from "@emotion/react";
import {
  constants,
  mediaQueryStyles,
  typographyStyles,
} from "@newsela/angelou";

const { mediaQuery: mq } = mediaQueryStyles;
const { sm, xs, md } = constants.breakpoints.BreakpointNames;

const { fontSize } = typographyStyles;

export const container: CSSObject = {
  marginBottom: "24px",
  paddingTop: "24px",
  width: "100%",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  textAlign: "center",

  [mq.downTo(xs)]: {
    padding: "40px 40px 28px 40px",
  },
};

export const headingWrapper: CSSObject = {
  display: "flex",
  alignItems: "center",
  marginBottom: "8px",
};

export const heading: CSSObject = {
  margin: "0",
  lineHeight: "2rem",
  fontFamily: "Noto Serif",
  fontSize: "24px",
  [mq.downTo(xs)]: {
    lineHeight: "2.5rem",
    fontSize: "32px",
  },
  [mq.downTo(md)]: {
    lineHeight: "3rem",
    fontSize: "40px",
  },
};

export const subHeadingWrapper: CSSObject = {
  display: "flex",
  margin: "8px 0 16px",
};

export const subHeading = (hasBorder: boolean): CSSObject => {
  return {
    ...fontSize.textXS,
    margin: "8px 0 8px 0",
    display: "flex",
    alignItems: "center",
    padding: "0px 8px 0px 8px",
    ...(hasBorder && { borderRight: "solid 2px rgba(29, 29, 29, 0.16)" }),

    [mq.downTo(xs)]: {
      ...fontSize.textM,
    },

    [mq.downTo(sm)]: {
      margin: "8px 0 16px 0",
    },
  };
};
